/**
* @ngdoc service
* @name common.service:StoreService
* @description
* Store main logic
*/
(function() {
    'use strict';

    angular
    .module('itxApp.common')
    .service('StoreService', StoreService);

    StoreService.$inject = [
        '$q',
        'logger'
    ];

    function StoreService (
        $q,
        logger
    ) {

        var service =  {
            getPhysicalStores: getPhysicalStores,
            getPhysicalStoreById: getPhysicalStoreById
        };

        return service;

        /**
        * @ngdoc method
        * @name getPhysicalStores
        * @methodOf common.service:StoreService
        * @description
        * Get a collection of physical stores for an online store.
        * @param {Object} criteria - Criteria for narrowing the search.
        * @param {bool} [criteria.favouriteStores=false] - If true, the favourite stores of the user are included in the
        *  results. Only valid for registered users.
        * @param {bool} [criteria.lastStores=false] - If true, the last stores used in previous orders are included in
        *  the results. Only valid for registered users.
        * @param {bool} [criteria.closerStores] - If true, returns the closest stores, based on longitude and
        *  latitude properties.
        * @param {number} [criteria.latitude] - The latitude of the point from which to search. Mandatory if
        *  closerStores is true.
        * @param {number} [criteria.longitude] - The longitude of the point from which to search. Mandatory if
        *  closerStores is true.
        * @param {number} min - The minimum desired number of stores to get.
        * @param {number} max - The maximum desired number of stores to get.
        * @param {number} radioMax - The maximum distance to search stores for.
        * @param {bool} [receiveEcommerce] - If true, the result list will exclude any stores that don't receive
        *  e-commerce orders.
        * @param {bool} [showBlockedMaxPackage] - If true, the receiveEcommerce param is ignored. Returns all 
        * the stores and indicates if the store is blocked by maximum package in the flag isBlocked.
        * @param {string} [countryCode] - If included, the result list will include only stores belonging to the
        *  indicated country.
        * @returns {Object} - An object with three arrays: favouriteStores, lastStores and closerStores, containing
        *  Store objects. The array may be empty depending on the options passed.
        */
        function getPhysicalStores(criteria){
            var deferred = $q.defer();

            var action = {
                action: 'bam:physicalStores1',
                params: {
                    storeId: inditex.iStoreId,
                    favouriteStores: criteria.favouriteStores || false,
                    lastStores: criteria.lastStores || false,
                    closerStores: criteria.closerStores || false,
                    latitude: criteria.latitude,
                    longitude: criteria.longitude,
                    min: criteria.min,
                    max: criteria.max,
                    radioMax: criteria.radioMax,
                    receiveEcommerce: criteria.receiveEcommerce,
                    showBlockedMaxPackage: criteria.showBlockedMaxPackage,
                    countryCode: criteria.countryCode || inditex.iCountryCode,
                    languageId: inditex.iLangId
                }
            };
    
            joyr.rest.xRestExecute([action])
            .done(function (data) {
                deferred.resolve(data[0]);
            })
            .Catch(function(error){
                deferred.reject(error);
            });

            return deferred.promise;
        }


        /**
        * @ngdoc method
        * @name getPhysicalStoreById
        * @methodOf  common.service:StoreService
        * @description
        * Returns the store object by ID.
        * @param {number} physicalStoreId Id of the store 
        */
        function getPhysicalStoreById(physicalStoreId){
            var deferred = $q.defer();
            logger.log('GET PHYSICAL STORE BY ID');            
            var action = {
                action: 'bam:physicalStore',
                params: {
                    storeId: inditex.iStoreId,
                    physicalStoreId: physicalStoreId,
                    languageId: inditex.iLangId
                }
            };
    
            joyr.rest.xRestExecute([action])
            .done(function (data) {
                deferred.resolve(data[0]);
            })
            .Catch(function(){
                deferred.reject();
            });
                
            return deferred.promise;
        }

    }

})();